import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/activity/CopilotMessageHeader.module_built.css";
const classes = {"copilot-message-header":"wyJATiG_copilot-message-header","copilot-message-header__avatar":"wyJATiG_copilot-message-header__avatar","copilot-message-header__title":"wyJATiG_copilot-message-header__title","copilot-message-header__ai-generated-content":"wyJATiG_copilot-message-header__ai-generated-content"}
export default classes

const _copilot_message_header0 = classes["copilot-message-header"]
export { _copilot_message_header0 as "copilot-message-header" }

const _copilot_message_header__avatar0 = classes["copilot-message-header__avatar"]
export { _copilot_message_header__avatar0 as "copilot-message-header__avatar" }

const _copilot_message_header__title0 = classes["copilot-message-header__title"]
export { _copilot_message_header__title0 as "copilot-message-header__title" }

const _copilot_message_header__ai_generated_content0 = classes["copilot-message-header__ai-generated-content"]
export { _copilot_message_header__ai_generated_content0 as "copilot-message-header__ai-generated-content" }
